module.exports = __webpack_public_path__ + "img/mostly_clear_night.5b6b6612.svg";